/*
 * @Author: “zhangjiahao04”
 * @Date: 2023-08-23 15:50:14
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-19 17:45:58
 * @FilePath: \pico-ow2c-fe\src\pages\outer\about\index.tsx
 * @Description: 关于我们——时间轴 组件
 * @url:www.picoxr.com/cn/about
 */
import React, { useState, useEffect } from "react";
import "./index.scss";
import styles from "../../index.module.scss";

import loadable from 'react-loadable'
import NoSSR from 'react-no-ssr';
import LazyMedia from "@/components/LazyMedia";
const CustomSwiper = loadable({
  loader: () => import('@/components/CustomSwiper'),
  loading: () => <div></div>,
})

interface Content {
  headline?: string; // 标题
  title?: string; // 产品名称
  characters?: string; // 产品简介
  cover?: any; // 产品封面
}
interface TimelineData {
  id: string;
  year: string; // 年份
  productName: string; // 产品名称
  content: Content; // 内容
}

interface ProductVoListItem {
  abbreviation: string; // 产品简称
  briefIntroduction: string; // 产品简介
  cover: any; // 产品封面
  id: string;
  name: string; // 产品名称
  time: string | null; // 产品发布时间
}

interface IProps {
  aboutUsProductVoList: ProductVoListItem[]; // 产品列表
  words: Record<string, string>;
}

const Timeline: React.FC<IProps> = ({ aboutUsProductVoList, words }) => {

  const [selectedYear, setSelectedYear] = useState<string | null>(null); // 当前选中的年份
  // 格式化数据
  const [timelineData] = useState<TimelineData[]>(
    aboutUsProductVoList && aboutUsProductVoList.length > 0 && aboutUsProductVoList.map((item: ProductVoListItem) => {
      return {
        id: item.id,
        year: item.time,
        productName: item.abbreviation,
        content: {
          headline: words?.about_us_development_milestones,
          title: item.name,
          characters: item.briefIntroduction,
          cover: item.cover.split(","),
        },
      };
    })
  );
  // 初始化展示内容
  const [content, setContent] = useState<Content>({
    headline: timelineData[0].content?.headline,
    title: timelineData[0].content?.title,
    characters: timelineData[0].content?.characters,
    cover: timelineData[0].content?.cover,
  });

  // 获取swiper实例 处理鼠标enter/leave时暂停/播放
  const [swiper, setSwiper] = React.useState<any>(null)
  useEffect(() => {
    if (swiper) {
      const swiperDom = swiper.$el[0]
      swiperDom.addEventListener('mouseenter', () => swiper.autoplay.stop())
      swiperDom.addEventListener('mouseleave', () => swiper.autoplay.start())
    }
  }, [swiper])

  const handleYearClick = (id: string) => {
    setSelectedYear(id);
    // 根据选中的年份更新展示的内容
    const selectedData = timelineData.find((data) => data.id === id);
    if (selectedData) {
      setContent(selectedData.content);
    }
  };

  // 初始化选中第一个年份
  useEffect(() => {
    if (timelineData.length > 0) {
      const initialYear = timelineData[0].id;
      handleYearClick(initialYear);
    }
  }, [timelineData]);

  return (
    <>
      {aboutUsProductVoList && (
        <div className={styles["time-line-warp"]}>
          <div className="timeline">
            {/* 上方内容展示区 */}
            <div className="content">
              {selectedYear && (
                <>
                  <h2>{content.headline}</h2>
                  <div className="content-detail">
                    <div className="content-left">
                      <NoSSR>
                        <CustomSwiper
                          loop={content?.cover.length > 1 ? true : false}
                          autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                          }}
                          setSwiper={setSwiper}>
                          {content?.cover.map((data: any, index: number) => (
                            <LazyMedia LazyClassName='full-wh' type="image" src={data} alt={data?.coverAlt} key={index} />
                          ))}
                        </CustomSwiper>
                      </NoSSR>
                    </div>
                    <div className="content-right">
                      <div className="title">{content.title}</div>
                      <div className="characters">{content.characters}</div>
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* 下方时间轴 */}
            <div className="timeline-list-warp">
              <div className="straight-line"></div>
              <ul className="timeline-list">
                {timelineData.map((data) => (
                  <li
                    key={data.id}
                    onClick={() => handleYearClick(data.id)}
                    className={`timeline-item ${
                      selectedYear === data.id ? "active" : ""
                    }`}
                  >
                    <div className="product-name" title={data.productName}>{data.productName}</div>
                    <div className="year-point-warp">
                      <div className="year-point" />
                    </div>
                    <div className="year-label">{data.year}</div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Timeline;
